export const useWindowFocus = (onFocus, onBlur) => {
  window.addEventListener("focus", onFocus);
  window.addEventListener("blur", onBlur);
};
